<template>
  <div class="card width-750">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <div class="columns is-marginless is-paddingless is-multiline">
        <b-field :label="$t('transmission.popUpAffecter.factor')" class="column">
          <b-autocomplete
            :value="nomFactor"
            :open-on-focus="openOnFocus"
            :data="dataFactors"
            field="nomWithAdresseAndCompteComptable"
            @select="selectFactor"
            @input="getFactor"
            :loading="isFetching"
            :placeholder="$t('transmission.popUpAffecter.searchFactor')">
            <template slot-scope="props">
              {{ props.option.nomWithAdresseAndCompteComptable }}
            </template>
            <template slot="empty">
              <div v-if="!isFetching">
                {{$t('general.autocomplete.noRslt')}}
              </div>
            </template>
          </b-autocomplete>
        </b-field>
      </div>
      <footer>
        <div class="has-text-centered">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered button-modal"
            @click="$parent.close()">
            {{ $t('general.button.cancel') }}
          </button>
          <button class="button is-primary has-text-centered mg-button-modal"
            @click="affecter()">
            {{ $t('transmission.popUpAffecter.affecter') }}
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import { getAll } from '@/api/tiers';
import { TIERS_TYPE_FOURNISSEUR, TIERS_SOUS_TYPE_FACTOR } from '@/configuration/tiers/tiersConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import messageErreur from '@/services/general/messageErreur';

const Societe = createNamespacedHelpers('societe');
export default {
  data() {
    return {
      nomFactor: null,
      isFetching: false,
      dataFactors: [],
      openOnFocus: false,
      tiersFactorId: null,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    getFormattageFactor(factor) {
      let libelle = factor.nomCommercial;
      if (adressFullStringGetter(factor.adressePostale, false) !== '') {
        libelle += ' - ' + adressFullStringGetter(factor.adressePostale, false);
      }
      if (factor.compteComptable) {
        libelle += ' - ' + factor.compteComptable;
      }
      return libelle;
    },
    getFactor: debounce(async function factorsData(text) {
      if (text === this.nomFactor) return;
      try {
        this.nomFactor = text;
        this.isFetching = true;
        this.tiersFactorId = null;
        const dataFactors = (await getAll({
          query: {
            type: TIERS_TYPE_FOURNISSEUR,
            auto: text,
            sousType: [TIERS_SOUS_TYPE_FACTOR],
            societeId: this.societeActiveId,
            archive: false,
          },
        })).data.result.items;
        dataFactors.map((factor) => {
          factor
            .nomWithAdresseAndCompteComptable = this.getFormattageFactor(factor);
          return factor;
        });
        this.dataFactors = dataFactors.filter((factor) => {
          return this.tiersFactorId !== factor.id;
        });
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw e;
      }
    }, 500),
    selectFactor(data) {
      if (data) {
        this.tiersFactorId = cloneDeep(data.id);
        this.nomFactor = cloneDeep(data.nomWithAdresseAndCompteComptable);
      }
    },
    affecter() {
      this.$emit('affecterFactor', this.tiersFactorId);
    },
  },
};
</script>

<style>

</style>
